package com.macrofocus.eflux.ui.perspective

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.ui.AppMenuComponent
import js.objects.unsafeJso
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import org.mkui.component.CPComponent
import react.FC
import react.Props
import web.cssom.Overflow
import web.cssom.Position
import web.cssom.pct
import web.cssom.px

class ParametersPerspective(private val dl: DataLoader) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        val theme = useTheme<Theme>()

        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx = unsafeJso {
                position = Position.absolute
                top = 0.px
//                bottom = 0.px
                maxHeight = 100.pct
                left = 0.px
                right = 0.px
                overflowY = Overflow.scroll

                customBackground(this)
            }

            AppMenuComponent {
                this.dataLoader = dl
                this.graphicalNetwork = null
                this.onCloseMenu = null
//                this.graphicalNetwork = dataLoader.diagramLoaders[0].graphicalNetwork
//                        attrs.currentUser = currentUser
//                this.onCloseMenu = ::closeMenu
            }
        }
    }

}